import React from "react";
import Common_Title from "../../common-components/common-btn/common-title/Common_Title";
import "./Cricket_Calculated.css";
import Common_Heading from "../../common-components/common-heading/Common_Heading";

import { Link } from "react-router-dom";

function Cricket_Calculated() {
  return (
    <div className="cricket-calculated">
      <div className="cricket-banner">
        <div className="container h-100">
          <div className="row h-100 align-items-center">
            <div className="col-12 col-md-4">
              <div className="common-title-wrapper"></div>
              <Common_Heading
                title_text="ABOUT US"
                head1="CRICKET,"
                head2="CALCULATED"
              />
            </div>

            <div className="col-md-8">
              <p className="cricket-description">
                At 11 Dreams, we believe cricket is more than just a sport; it's
                a heartbeat. Our platform is built by fans, for fans, with a
                single mission: to bring you closer to the pitch than ever
                before. We provide a seamless, high-octane experience that turns
                your cricket knowledge into real-world rewards. Whether it’s a
                local T20 or the World Cup final, 11 Dreams is where your
                strategy meets the boundary.
              </p>

              <Link to="/aboutus">
                <button className="read-more-btn">READ MORE</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cricket_Calculated;
